<template>
    <div>
      <!-- You can add additional template content here -->
    </div>
  </template>
  
  <script>
  import Swal from 'sweetalert2';
  
  export default {
    name: "ExpiredAlert",
    props: {
      expirationDate: {
        type: Number,
        required: true,
      },
    },
    data() {
      return {
        visible: false, // Initially set to false
        remainingTime: null, // Store the remaining time in seconds
        countdownInterval: null, // Store the interval ID
      };
    },
    computed: {
      isExpired() {
        return new Date() >= this.expirationDate * 1000; // Check if the current date is past the expiration date in milliseconds
      },
      formattedExpirationDate() {
        const date = new Date(this.expirationDate * 1000); // Convert to milliseconds
        const options = { 
          year: 'numeric', 
          month: 'long', 
          day: 'numeric', 
          hour: '2-digit', 
          minute: '2-digit', 
          second: '2-digit', 
          timeZoneName: 'short' 
        };
        return date.toLocaleString('id-ID', options); // Format the date
      },
    },
    methods: {
      closeDialog() {
        this.visible = false;
        clearInterval(this.countdownInterval); // Clear the interval when the dialog is closed
      },
      extendLogin() {
        // Logic to extend login goes here
        this.closeDialog();
        this.$emit("extend"); // Emit an event to the parent component
      },
      checkExpiration() {
        
        if (this.isExpired) {
          this.visible = true; // Open the dialog if the token is expired
          clearInterval(this.countdownInterval); // Clear interval when dialog is shown
        } else {
          // Calculate the remaining time until expiration
          this.remainingTime = Math.ceil((this.expirationDate * 1000 - new Date()) / 1000);
          clearInterval(this.countdownInterval); // Clear interval when dialog is shown
          this.startCountdown();
        }
      },
      startCountdown() {
        this.countdownInterval = setInterval(() => {
          if (this.remainingTime > 0) {
            // console.log(this.remainingTime + " seconds remaining until expiration");
            this.remainingTime--; // Decrement remaining time
          } else {
            clearInterval(this.countdownInterval); // Clear interval when countdown is complete
            this.showIdleAlert(); // Show the idle alert
          }
        }, 1000); // Update every second
      },
      async showIdleAlert() {
        let self = this
        const result = await  Swal.fire({
    title: "Session Expired",
    html: "You will be logged out because your session has expired",
    icon: "warning",
    // showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "<span style='color: white;'>OK</span>",
    // cancelButtonText: "<span style='color: white;'>NO</span>"
    }).then(async (result) => {
            if (result.isConfirmed) {
                
            return this.$router.push("/logout");
            }else{

            return this.$router.push("/logout");
            }
            });
  
        if (result.isConfirmed) {
          this.extendLogin(); // Call the extend login function
        } else {
          // Handle the case where the user selects "No" (optional)
          console.log("User is no longer active.");
        }
      },
    },
    mounted() {
      this.checkExpiration(); // Check expiration status when the component is mounted
      // If the session is expired, show the dialog immediately
      if (this.isExpired) {
        this.visible = true;
      }
    },
    watch: {
      expirationDate: 'checkExpiration', // Check expiration whenever expirationDate changes
    },
  };
  </script>
  
  <style scoped>
  /* Custom styles for SweetAlert2 */
  .my-swal {
    background-color: #f0f4ff; /* Light blue background */
    border: 2px solid #007bff; /* Blue border */
    border-radius: 10px; /* Rounded corners */
    padding: 20px; /* Padding inside the alert */
  }
  
  .my-swal .swal2-title {
    color: #007bff; /* Blue color for the title */
    font-weight: bold; /* Bold title */
  }
  
  .my-swal .swal2-confirm {
    background-color: #007bff; /* Blue button */
    color: white; /* White text */
    border-radius: 5px; /* Rounded button */
  }
  
  .my-swal .swal2-cancel {
    background-color: #ff4d4d; /* Red button */
    color: white; /* White text */
    border-radius: 5px; /* Rounded button */
  }
  </style>
  